import styled, { css } from 'styled-components';
import { media, remCalc, colors, layout } from '@prisjakt/ui-base';
import { Link as LinkComponent } from 'react-router-dom';
import CorePropertiesComponent from '@prisjakt/ui-core-properties';
import CampaignLabelComponent from '../../../../components/campaign-label';

export const ProductSummary = styled.div`
  flex: 0 0 auto;
  width: 300px;
  margin-right: 10px;

  ${media.mediumDown`
    width: 210px;
  `}
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;

  ${media.smallOnly`
    margin: 0 10px;
  `};
`;

type TitleProps = {
  inner?: boolean;
  outer?: boolean;
  'data-test': string;
};
export const Title = styled.h1<TitleProps>`
  font-size: ${remCalc(22)};
  font-weight: normal;
  margin-bottom: ${remCalc(10)};

  ${props =>
    props.inner &&
    css`
      margin-right: 20px;
    `}

  ${props =>
    props.outer &&
    css`
      flex: 1 0 auto;
      margin-bottom: 10px;
      margin-right: 0px;
    `}
`;

export const More = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ProductActions = styled.div`
  margin: 10px 0 20px 0;
`;

export const Content = styled.div`
  display: flex;
`;

export const StoreLogo = styled(LinkComponent)`
  position: absolute;
  text-align: center;
  bottom: calc(100% + 5px);
  right: 10px;

  img {
    max-width: 88px;
  }
`;

export const CategoryRank = styled.div`
  font-size: 14px;
  margin-bottom: ${remCalc(10)};
  color: ${colors.darkGray4};
`;

export const RelatedPage = styled.div`
  font-size: ${remCalc(14)};
  margin-bottom: ${remCalc(10)};
  color: ${p => p.theme.text.secondary};

  a,
  .pj-ui-scroll-link {
    color: ${p => p.theme.text.callToAction};
    cursor: pointer;
    outline: none;
    &:hover,
    &:focus {
      color: ${p => p.theme.text.callToActionHover};
      text-decoration: underline;
    }
  }
`;

export const CategoryRankPill = styled.span`
  font-size: 12px;
  background: ${p => p.theme.pill.primary.bg};
  color: ${p => p.theme.pill.primary.text};
  font-weight: bold;
  text-transform: uppercase;
  padding: 2px 4px;
  border-radius: 2px;
  margin-bottom: 2px;
`;

export const CategoryRankNumber = styled.span`
  color: ${p => p.theme.pill.primary.text};
`;

export const RatingWrapper = styled.div`
  margin-bottom: ${remCalc(10)};
  text-decoration: underline;
  color: ${p => p.theme.text.callToAction};

  span {
    color: inherit;
  }
  &:hover span {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const DisplayProperties = styled(CorePropertiesComponent)`
  margin: 0 0 ${remCalc(8)};
`;

export const ReviewBadges = styled.div`
  margin: 0 0 ${remCalc(8)};
`;

export const CampaignLabel = styled(CampaignLabelComponent)``;

export const Link = styled(LinkComponent)`
  color: ${colors.lightBlue3};
  cursor: pointer;
  outline: none;

  &:hover,
  &:focus {
    color: ${colors.green1};
    text-decoration: underline;
  }
`;

export const RankContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  > :not(:last-child) {
    margin-right: ${layout.spacing.xSmall};
  }
`;
